import Vue from "@/main"
let timeoutId = null
export default {
  /**
   * 中英文切换
   * @param {String} lang
   * en: 英文
   * zh: 中文
   */
  changeLanguage (lang) {
    let oldLang = localStorage.getItem('lang')
    localStorage.setItem('lang', lang)
    Vue.$i18n.locale = lang
    if (oldLang != lang) {
      const loading = Vue.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, .9)'
      });
      setTimeout(() => {
        location.reload()
        loading.close();
      }, 500);
    }
  },
  getUserScreen () {
    return {
      width: screen.width,
      height: screen.height
    }
  },
  /**
   * 时间处理
   * @param {Date} date
   * @param {Boolean} needDetail 需要时分秒
   */
  formatterDate (date, needDetail) {
    let options = {}
    if (needDetail) {
      options = {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      }
    }
    return date.toLocaleString('zh-cn', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      ...options
    }).replace(/\//g, '-');
  },
  /**
   * 获取晚数
   * @param {Date} date1
   * @param {Date} date2
   */
  getNinghtCount (date1, date2) {
    return (new Date(date2).getTime() - new Date(date1).getTime()) / 86400000
  },
  /**
   * 是否已登录
   */
  isLogin () {
    const partnerInfo = localStorage.getItem('partnerInfo')
    return partnerInfo
  },
  /**
   * 退出登录
   * @param {*} toLogin 需返回登录页面
   * @param {*} needConfirm 取消退出询问
   */
  loginOut (toLogin, needConfirm) {
    if (needConfirm) {
      localStorage.removeItem('partnerInfo')
      sessionStorage.removeItem('homeSearchForm')
      Vue.$router.replace('/login')
      return
    }
    Vue.$confirm(`${Vue.$t('header.confirm_login_out')}?`, Vue.$t('header.Reminder'), {
      confirmButtonText: Vue.$t('header.confirm'),
      cancelButtonText: Vue.$t('header.cancel'),
      type: 'warning'
    }).then(() => {
      localStorage.removeItem('partnerInfo')
      sessionStorage.removeItem('homeSearchForm')
      if (toLogin) {
        Vue.$router.replace('/login')
      } else {
        location.reload()
      }
    }).catch(() => {

    });
  },
  /**
   * 获取屏幕信息
   */
  getScreenInfo () {
    return document.documentElement.getBoundingClientRect()
  },
  /**
   * 账号类型 1：国内 2：海外 3：全部
   */
  getAccountType () {
    const partnerInfo = JSON.parse(localStorage.getItem('partnerInfo'))
    if (partnerInfo) {
      if (partnerInfo.homeChannelId && partnerInfo.overseaChannelId) {
        return 3;
      }
      if (partnerInfo.overseaChannelId && !partnerInfo.homeChannelId) {
        return 2
      }
      if (!partnerInfo.overseaChannelId && partnerInfo.homeChannelId) {
        return 1
      }
    }
  },
  debounce (func, delay) {
    if (timeoutId) {
      clearTimeout(timeoutId)
      timeoutId = null
    }
    timeoutId = setTimeout(() => {
      func.apply(this, arguments)
    }, delay)
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/NewCommonUtil.js